
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
interface IGraficoCalibracao{

  id: string
  total: number
  analisados: number
  calibradosAderencia: number
  aderenciaOriginal: number
}

export const GraficoCalibracao: React.FC<IGraficoCalibracao> = ({ id, aderenciaOriginal, analisados, calibradosAderencia, total }) => {
  function GerarGrafico(): void {
    const options = {
      series: [
        // {
        //   name: 'Total perfis',
        //   data: [analisados, aderenciaOriginal, calibradosAderencia]
        // }
        {
          name: 'Original',
          data: [aderenciaOriginal]
        },
        {
          name: 'Calibrados',
          data: [calibradosAderencia]
        }
      ],

      chart: {
        type: 'bar',
        stacked: true,
        height: 450,
        width: 405
      },

      plotOptions: {
        bar: {
          // distributed: true,
          horizontal: false,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: '12px',
                fontWeight: 900
              }
            }

          }
        }
      },
      colors: ['#218d4c', '#c41df7'],
      title: {
        text: 'Análise aderência'
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: number) {
          return val.toString()
        },
        offsetY: 0,
        style: {
          fontSize: '12px',
          colors: ['#000']
        }
      },
      xaxis: {
        categories: ['Aderência']
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [total, aderenciaOriginal])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
